








import { defineComponent, computed } from '@vue/composition-api';

const CommonCheckButton = defineComponent({
  setup(props) {
    const icon = computed(() => {
      if (!props.status) return 'vivat/icons/check-empty.png';
      return 'vivat/icons/check-checked.png';
    });

    return {
      icon,
    };
  },
  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },
});

export default CommonCheckButton;
